import type { FC } from "react";
import React from "react";

import { hasValue } from "@core/foundation/types";

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "@react/ui-primitives/dialog";

import type { MemoryApiKey } from "@apis/memory/models";

import { MemoryApiKeyContent } from "./MemoryApiKeyContent.tsx";

interface MemoryApiKeyDialogProps {
  readonly memoryApiCredential: null | string;
  readonly memoryApiKey: MemoryApiKey | null;
  readonly onOpenChange: (open: boolean) => void;
  readonly open: boolean;
}

export const MemoryApiKeyDialog: FC<MemoryApiKeyDialogProps> = ({
  memoryApiCredential,
  memoryApiKey,
  onOpenChange,
  open,
}) => (
  <Dialog onOpenChange={onOpenChange} open={open}>
    <DialogContent>
      <DialogHeader>
        <DialogTitle>Memory API key</DialogTitle>
        <DialogDescription>
          The credential combines this key with your account and project IDs.
          Copy the credential now; it cannot be shown again.
        </DialogDescription>
      </DialogHeader>
      {hasValue(memoryApiCredential) && hasValue(memoryApiKey) && (
        <MemoryApiKeyContent
          memoryApiCredential={memoryApiCredential}
          memoryApiKey={memoryApiKey}
        />
      )}
    </DialogContent>
  </Dialog>
);
